import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { GUIDES } from "@/config/site";

const Guide = () => (
    <main className="pt-32 sm:pt-40 pb-24 min-h-screen">
        <Seo
            title="The BSK Jewellery Guide — Gold Purity, Hallmarking, Diamond 4Cs | BSK Jewellers"
            siteName="BSK Jewellers"
            description="Learn about gold purity, 18K vs 22K, BIS hallmarking, the diamond 4Cs, engagement rings, bridal jewellery and jewellery care — the BSK Jewellery Guide, Amritsar."
            image="/images/diamond-macro.jpg"
        />
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
            <SectionHeading
                align="left"
                eyebrow="Knowledge Centre"
                title={<>The BSK <span className="italic gold-text">Jewellery Guide</span></>}
                copy="Honest, simple answers about gold, diamonds and care — so you can buy with complete confidence."
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="guide-grid">
                {GUIDES.map((g, i) => (
                    <Reveal key={g.slug} delay={(i % 3) * 0.07}>
                        <Link to={`/guide/${g.slug}`} data-testid={`guide-card-${g.slug}`} className="group block border border-gold/10 hover:border-gold/50 transition-colors duration-500 bg-charcoal/40 h-full">
                            <div className="aspect-[16/9] overflow-hidden">
                                <img src={g.image} alt={g.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                            </div>
                            <div className="p-7">
                                <p className="text-[10px] tracking-[0.25em] uppercase text-gold">{g.readTime} read</p>
                                <h2 className="font-serif text-2xl text-ivory mt-2 group-hover:text-gold transition-colors">{g.title}</h2>
                                <p className="text-sm text-sand mt-3 leading-relaxed">{g.excerpt}</p>
                                <span className="inline-block text-[10px] tracking-[0.25em] uppercase text-sand mt-5 border-b border-gold/40 pb-0.5 group-hover:text-gold transition-colors">Read Guide →</span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    </main>
);

export default Guide;
